var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagFrCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#000",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#283264",
  d: "M-1.192-3C-2.743-3-4-1.352-4 .68v21.642c0 2.03 1.257 3.677 2.808 3.678H7V-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFBFA",
  d: "M7 26h10V-3H7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BD2B38",
  d: "M25.192-3H17v29h8.192C26.742 26 28 24.353 28 22.322V.68C28-1.352 26.743-3 25.192-3"
}))));
export { SvgFlagFrCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjExIiBmaWxsPSJibGFjayIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiAvPgogICAgPG1hc2sgaWQ9Im1hc2swXzBfMTQ0MyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMSIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjbWFzazBfMF8xNDQzKSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgZD0iTS0xLjE5MjIgLTNDLTIuNzQzMDggLTIuOTk5MiAtNCAtMS4zNTE5MyAtNCAwLjY3OTc4OVYyMi4zMjE3Qy0zLjk5OTM5IDI0LjM1MjggLTIuNzQyNjUgMjUuOTk5MiAtMS4xOTIyIDI2SDdWLTNILTEuMTkyMiIKICAgICAgICAgICAgZmlsbD0iIzI4MzI2NCIgLz4KICAgICAgICA8cGF0aCBkPSJNNyAyNkgxN1YtM0g3TDcgMjZaIiBmaWxsPSIjRkNGQkZBIiAvPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0yNS4xOTIyIC0zSDE3VjI2SDI1LjE5MjJDMjYuNzQyOSAyNiAyOCAyNC4zNTMyIDI4IDIyLjMyMTdWMC42Nzk3ODlDMjggLTEuMzUxOTMgMjYuNzQzMSAtMi45OTkyIDI1LjE5MjIgLTMiCiAgICAgICAgICAgIGZpbGw9IiNCRDJCMzgiIC8+CiAgICA8L2c+Cjwvc3ZnPg==";